import { render, staticRenderFns } from "./Espacos.vue?vue&type=template&id=77842ef4&"
import script from "./Espacos.vue?vue&type=script&lang=js&"
export * from "./Espacos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports